import { useEffect, useState } from "react";

const WA_LINK =
  "https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20to%20book%20an%20appointment.";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 80% of viewport height (hero section)
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Pulse every 4 seconds to attract attention
  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    }, 4000);
    return () => clearInterval(interval);
  }, [visible]);

  return (
    <div
      className={`fixed bottom-6 right-4 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-8 pointer-events-none"
      }`}
    >
      {/* Tooltip label */}
      <div
        className={`transition-all duration-300 ${
          visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4"
        }`}
        style={{ transitionDelay: visible ? "200ms" : "0ms" }}
      >
        <div className="bg-[#1a2744] text-white text-xs tracking-wide px-3 py-1.5 rounded-sm flex items-center gap-2 whitespace-nowrap">
          <span style={{ fontFamily: "'Playfair Display', serif" }}>Book Now</span>
          <span className="text-[#c6a864] text-xs" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>احجزي الآن</span>
        </div>
        {/* Arrow pointing right */}
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-0 h-0"
          style={{ borderTop: "5px solid transparent", borderBottom: "5px solid transparent", borderLeft: "5px solid #1a2744" }}
        />
      </div>

      {/* WhatsApp button */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Book via WhatsApp"
        className={`cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white transition-all duration-300 hover:scale-110 hover:bg-[#20ba5a] ${
          pulse ? "scale-110" : "scale-100"
        }`}
        style={{
          boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)",
        }}
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>

      {/* Gold ring pulse animation */}
      {pulse && (
        <span
          className="absolute bottom-0 right-0 w-14 h-14 rounded-full bg-[#25D366]/30 animate-ping"
          style={{ pointerEvents: "none" }}
        />
      )}
    </div>
  );
}